import { useEffect, useState } from "react";

// STYLES
import * as Style from "./DashboardStyle";

// LIBRARIES

// MISC

// ASSETS

// REDUX
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import { getStatistics } from "api/statisticsApi";
import { statistics } from "slices/statisticsSlice";

// COMPONENTS
import ReportStatistics from "components/ReportStatistics/ReportStatistics";
import RentStatistics from "components/RentStatistics/RentStatistics";
import NewcomeUsers from "components/NewcomeUsers/NewcomeUsers";
import LockerStatistics from "components/LockerStatistics/LockerStatistics";

const Dashboard = () => {
  // PROPS

  // CONSTANTS USING LIBRARIES
  const dispatch = useAppDispatch();
  const statisticsData = useAppSelector(statistics);

  // CONSTANTS USING HOOKS
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION
  useEffect(() => {
    setIsLoading(true)
    dispatch(getStatistics())
      .then(() => {
        setIsLoading(false);
      })
    //eslint-disable-next-line
  }, []);

  // Helper function to check if user is "mondo"
  const isMondoUser = () => {
    const username = localStorage.getItem('username');
    return username === 'mondo';
  };

  // Filter locker statistics for mondo user
  const getFilteredLockerStatistics = () => {
    if (isMondoUser() && statisticsData?.lockers) {
      return {
        ...statisticsData,
        lockers: statisticsData.lockers.filter(locker => locker.id === 56)
      };
    }
    return statisticsData;
  };
  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS

  return (
    <>
      {!isLoading ?
        <Style.DashboardContainer>
          <ReportStatistics reportStatisticsData={statisticsData} />
          <RentStatistics rentStatisticsData={statisticsData} />
          <NewcomeUsers recentRegisteredUsersStatisticsData={statisticsData} />
          <LockerStatistics lockersStatisticsData={getFilteredLockerStatistics()} />
        </Style.DashboardContainer>
        :
        <Style.LoadingContainer>
          <Style.LodingSign />
        </Style.LoadingContainer>}
    </>
  );
};

export default Dashboard;
